const debtIssueDetailReport = {
  label: "DebtIssue Detail Report",
  name: "debtIssueDetailReport",
  parameters: [
    {
      name: "database",
      label: "Database",
      type: "select",
      defaultValue: "hero",
      options: [
        { key: "hero", label: "HERO" },
        { key: "data", label: "Other" },
      ],
    },
  ],
};

export default debtIssueDetailReport;
